<template>
  <div>
    <!-- 欠费 补缴页面支付 -->
    <van-nav-bar
      class="backBox"
      title="欠费订单"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div>
        <!-- 顶部吸顶 时间范围： 近一年  -->
      <div class="topTime">
        <span class="topTimeText">时间范围：</span>
        <span class="topTimeDate">近一年</span>
      </div>
      </div>
    <div class="container">
      <div
        class="escapeListBox"
      >

    <div
        class="escapeListBox"
        v-for="(item, index) in escDataInfoList"
        :key="index"
      >
        <div class="boxTop">
          <div class="row1 tit">
            <div class="number">
              <span class="normal">{{ item.vh_p_number }}</span>
            </div>
          </div>
          <div class="escPrice">
            <span class="couponPrice"
              >{{ (item.fee_value / 100).toFixed(2) }}
              <span style="font-size: 0.14rem">元</span></span
            >
          </div>
          <div class="escPrice">
            <span class="tit">欠费订单</span>
          </div>
          <div class="itemText">
            <span class="time-tip">车场全称:</span>
            <span class="in-time">{{ parkName }}</span>
          </div>
          <div class="itemText">
            <span class="time-tip">订单号:</span>
            <span class="in-time">{{ item.fee_order_sn }}</span>
          </div>
          <div class="itemText">
            <span class="time-tip">入场时间:</span>
            <span class="in-time">{{ formatDate(item.in_time) }}</span>
          </div>
          <div class="itemText">
            <span class="time-tip">出场时间:</span>
            <span class="in-time">{{ formatDate(item.out_time) }}</span>
          </div>
          <div class="itemText">
            <span class="time-tip">停车时长:</span>

            <span class="in-time">{{ item | formatParkTime }} </span>
          </div>
          <div class="itemText">
            <span class="time-tip">入场车道:</span>
            <span class="in-time">{{ item.in_channel_name }}</span>
          </div>
          <div class="itemText">
            <span class="time-tip">出场车道:</span>
            <span class="in-time">{{ item.out_channel_name }}</span>
          </div>

          <div class="itemText">
            <span class="time-tip">出入场照片:</span>
            <span class="in-time viewImg" @click="openInOutImg(item)"
              >查看详情</span
            >
          </div>
        </div>

        <div class="boxBottom">
          <div class="comment">
            <span class="time-tip">备注:</span>
            <span class="in-time">{{ item.cancel_comment }}</span>
          </div>

          <div class="button-row-pay">
            <van-button
              class="escBtn"
              type="info"
              size="large"
              @click="viewVideo(item)"
              >查看过车视频</van-button
            >
          </div>
        </div>
      </div>
      </div>

      <!-- 查看照片 -->
      <van-dialog
        v-model="showImg"
        title="进出场照片详情"
        confirm-button-color="#1989fa"
      >
        <div style="text-align: center; margin-top: 3%" v-if="isLoadingImg">
          <van-loading color="#1989fa" text-color="#999" vertical
            >图片加载中，请稍后...</van-loading
          >
        </div>
        <div class="imgBox" v-for="item in inoutImgs" :key="item.id">
          <div class="imgItem">
            <van-image
              width="260"
              height="160"
              v-if="!item.loadError && item.url"
              :src="item.url"
              fit="cover"
              @error="onImgError(item)"
            >
              <template v-slot:default>
                <div style="text-align: center; font-size: 0.12rem">
                  {{ item.text }}
                </div>
              </template>

              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>

            <!-- 如果没有图片 或 加载失败，就显示纯文本 -->
            <div
              v-else
              style="width: 260px; height: 160px; display: flex; align-items: center; justify-content: center; background: #f5f5f5; color: #999;"
            >
              {{ item.text }}（暂无图片）
            </div>
          </div>
        </div>

      </van-dialog>

      <!-- 查看过车视频 -->
      <van-dialog
        v-model="showVideo"
        title="过车视频"
        confirm-button-color="#1989fa"
        :show-confirm-button="true"
        :close-on-click-overlay="true"
        class="video-dialog"
        @closed="onVideoDialogClosed"
      >
        <div class="videoBox" v-if="videoUrl">
          <video
            ref="videoPlayer"
            :src="videoUrl"
            controls
            preload="metadata"
            class="video-player"
            @error="onVideoError"
          >
            您的浏览器不支持视频播放
          </video>
        </div>
        <div v-else class="video-error">
          视频加载失败，请稍后重试
        </div>
      </van-dialog>

      <div class="escapeListEmptyBox" v-show="escDataInfoList.length === 0">
            <van-empty description="暂无欠费订单" />

      </div>

      <div class="banner" v-if="adConfigReady && !isCloseAD">
        <adver position="EXIT_ORDER_BANNER"></adver>
      </div>
      <!-- 分页 -->
      <div class="pageOptionsBox" v-show="escDataInfoList.length > 0">
        <van-pagination
        v-model="pageOptions.page_no"
        :total-items="pageOptions.total"
        :items-per-page="pageOptions.page_size"
        mode="simple"
        @change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import * as mqtt from '../../api/mqtt/wsconnect'
import * as util from '../../api/util'
import * as common from '../../api/common'
import * as constant from '../../api/constant'
import * as api from '../../api/api'
// import { Toast } from 'vant'
import Adver from '../../components/Adver.vue'
import { Toast } from 'vant'

export default {
  name: 'pay_escape',
  components: {
    Adver
  },
  data () {
    return {
      parkName: '',
      showImg: false,
      inOrOut: '',
      // inImg: 'https://img01.yzcdn.cn/vant/apple-3.jpg',
      inImg: '',
      outImg: '',
      vh_out_id: '',
      inoutImgs: [],
      isLoadingImg: false,
      // add
      btn_del: false,
      // sid: '',
      plate_number: '',
      car_type: '',
      gross_price: 0,
      actually_paid: 0,
      payablefee: 0,
      start_time: '',
      end_time: '',
      in_time: '',
      hour: '',
      min: '',
      seconds: '',
      sign: '',
      req_order_sn: '',
      code: '',
      appidLocal: '', // 当前sid对应的appid
      selectType: [],
      selectid: [],
      selectRuleId: [],
      Price: '',
      couponPrice: '',
      couponPrice1: '',
      visible: false,
      couponType: {
        money: 1, // 减免金额
        time: 2, // 减免时间
        disBreaks: 3, // 打折减免
        free: 4 // 全免
      },
      list: [],
      isVueReady: false,
      isTypeReady: false,
      isEmqxConnect: false,
      isPress: false,
      escapeOrder: '',
      pay_channel_platform: '',
      pay_channel: '',
      localInfo: {},
      escDataInfo: [],
      isCloseAD: false,
      adConfigReady: false,
      sid: '',
      channel_path: '',
      direction: '',
      escDataInfoList: [
        // {
        //   id: 1,
        //   vh_p_number: '粤A12345',
        //   fee_value: 100,
        //   fee_order_sn: '202301010001',
        // },
        // {
        //   id: 1,
        //   vh_p_number: '粤B12345',
        //   fee_value: 100,
        //   fee_order_sn: '202301010001',
        // },
        // {
        //   id: 1,
        //   vh_p_number: '粤C12345',
        //   fee_value: 100,
        //   fee_order_sn: '202301010001',
        // },

      ],
      pageOptions: {
        page_no: 1,
        page_size: 10,
        total: 47
      },
      time_start: '',
      time_end: '',
      vh_p_number: '',
      methodName: 'vh_fee_order_escape.get_escape_info',
      escapeImgTopic: 'vh_inout.get_pic_from_pic_file_id',
      needPageQryFlag: false, // 是否需要通过接口分页查询欠费订单；true是；false否，直接使用传进来的欠费List进行渲染；
      videoUrl: '',
      showVideo: false
    }
  },
  computed: {
    ...mapState({
      plateNumber: state => state.plateNumber.plateNumber,
      adverInfo: state => state.adverInfo.adverInfo,
      payType: state => state.payType.payType,
      //   sid: state => state.sid.sid,
      saveRouteQueryData: state => state.saveRouteQueryData.saveRouteQueryData,
      appid: state => state.appid.appid,
      codeLocal: state => state.code.code
    })
  },
  watch: {
    // 监听 showVideo 变化，确保关闭时停止视频
    showVideo (newVal) {
      if (!newVal) {
        // Dialog 关闭时停止视频
        this.$nextTick(() => {
          this.stopVideo()
        })
      }
    }
  },
  created () {
  },
  mounted () {
    this.queryADConfig()
    const escData = JSON.parse(this.$route.query.escData)
    console.log('query详情', this.$route.query)
    console.log('逃费订单详情', escData)
    // const localInfo = JSON.parse(this.$route.query.localInfo)
    // this.localInfo = localInfo

    this.sid = this.$route.query.sid
    this.channel_path = Number(this.$route.query.channel_path)
    this.parkName = this.$route.query.parkName
    this.direction = Number(this.$route.query.direction)
    this.needPageQryFlag = this.$route.query.needPageQryFlag === 'true'
    this.vh_p_number = this.$route.query.vh_p_number
    this.time_start = this.$route.query.time_start
    this.time_end = this.$route.query.time_end
    console.log('needPageQryFlag', this.needPageQryFlag)
    if (this.needPageQryFlag === true) {
      this.getMoreEscape()
      console.log('需要分页查询')
    } else {
      this.escDataInfoList = escData
      console.log('不需要分页查询')
      this.pageOptions.total = escData.length
      this.pageOptions.page_no = 1
      this.pageOptions.page_size = 10
    }
  },
  methods: {
    // 查看过车视频
    async viewVideo (item) {
      const videoOssPath = (item && item.video_oss_path) || ''

      if (!videoOssPath) {
        Toast('暂无视频')
        return
      }

      // 显示加载提示
      const loadingToast = Toast.loading({
        forbidClick: true,
        message: '正在加载视频...'
      })

      try {
        const { IotService } = await import('../../api/iotService')
        const { data } = await IotService.callS2pApi(api.urlList.oss.yuen.get_escape_url, {
          path: videoOssPath
        })

        loadingToast.clear()
        console.log('获取视频url data', data)
        console.log('data类型:', typeof data)
        console.log('data是否为对象:', typeof data === 'object' && data !== null)
        console.log('data.url:', data && data.url)
        console.log('data的所有键:', data && Object.keys(data))

        // 检查 data 的类型，可能是字符串需要解析
        let videoUrl = ''
        if (typeof data === 'string') {
          console.log('data是字符串', data)
          try {
            const parsedData = JSON.parse(data)
            videoUrl = (parsedData && parsedData.url) || ''
          } catch (e) {
            console.error('解析data字符串失败', e)
          }
        } else if (data && typeof data === 'object') {
          console.log('data是对象', data)
          videoUrl = data.url || ''
        }

        console.log('最终videoUrl:', videoUrl)

        if (videoUrl) {
          this.videoUrl = videoUrl
          this.showVideo = true
        } else {
          Toast('视频地址无效')
        }
      } catch (error) {
        loadingToast.clear()
        console.error('获取视频失败', error)
        Toast('获取视频失败，请稍后重试')
      }
    },
    onPageChange (val) {
      console.log('onPageChange当前第几页', val)
      this.pageOptions.page_no = val
      this.getMoreEscape()
    },
    async getMoreEscape () {
      Toast.loading({
        forbidClick: true,
        message: '请稍候...'
      })
      try {
        const { data } = await axios({
          url: common.reqMqCloudUrl + '/api/no_sign/request.pls_req',
          method: 'POST',
          data: {
            sid: this.sid || this.$route.query.sid,
            method: this.methodName,
            // openid: this.openID,
            params: {
              vh_p_number: this.vh_p_number,
              sid: this.sid || this.$route.query.sid,
              page_size: this.pageOptions.page_size,
              page_no: this.pageOptions.page_no,
              time_start: this.time_start,
              time_end: this.time_end
            }
          },
          header: {
            'content-type': 'application/json' // 默认值
          }
        })
        console.log('查询欠费信息data', data)
        // todo data.data就是后续要传的 local_info
        if (data.code === 10000 && data.data) {
          console.log('接收到入口缴费Info', data.data)
          // TODO 如果data.data 是纯文本 则直接输入该提示 说明在通道内没有查询到
          if (typeof data.data !== 'object' || data.data === null || Array.isArray(data.data)) {
            if (typeof data.data === 'string') {
              Toast(data.data)
            } else {
              Toast('数据格式异常')
            }
            return
          }
          this.$toast.clear()
          const info = data.data
          console.log('+++', info)
          this.escDataInfoList = data.data.escInfo.list
          this.pageOptions.total = data.data.escInfo.total
        } else {
          this.$toast.clear()
          Toast('获取车辆逃费信息失败：' + data.msg || '查询出错，请稍后重试')
        }
      } catch (e) {
        this.$toast.clear()
        Toast(e || '查询异常，请稍后')
      }
    },
    // 获取关闭广告配置
    queryADConfig () {
      const flag = util.judgeADClose({}, 2, 2)
      this.isCloseAD = flag
      this.adConfigReady = true
    },
    onClickLeft () {
      console.log('点击返回', this.sid)
      if (this.direction === 1) {
        this.$router.replace({
          path: '/fee_in_escape',
          query: {
            sid: this.sid,
            channel_path: this.channel_path
          }
        })
      } else {
        let saveRouteQueryDataLocal
        if (sessionStorage.getItem(constant.keySaveRouteQueryDataVuex)) {
          saveRouteQueryDataLocal = JSON.parse(sessionStorage.getItem(constant.keySaveRouteQueryDataVuex))
        }
        this.$router.replace({
          path: '/vh_fee_order_escape_out',
          query: {
            plate_number: saveRouteQueryDataLocal.plate_number,
            gross_price: saveRouteQueryDataLocal.gross_price,
            req_order_sn: saveRouteQueryDataLocal.req_order_sn,
            start_time: saveRouteQueryDataLocal.start_time,
            end_time: saveRouteQueryDataLocal.end_time,
            sign: saveRouteQueryDataLocal.sign,
            localInfo: saveRouteQueryDataLocal.localInfo,
            escape_info: saveRouteQueryDataLocal.escape_info,
            pay_channel_platform: saveRouteQueryDataLocal.pay_channel_platform,
            receive_timestamp: saveRouteQueryDataLocal.receive_timestamp
          }
        })
      }
    },

    strToDate (dateObj) {
      if (dateObj) {
        dateObj = dateObj
          .replace(/T/g, ' ')
          .replace(/\.[\d]{3}Z/, '')
          .replace(/(-)/g, '/')
        if (dateObj.indexOf('.') > 0) { dateObj = dateObj.slice(0, dateObj.indexOf('.')) }
        return new Date(dateObj)
      } else {
        return ''
      }
    },
    // 查看进出场图片
    async openInOutImg (row) {
      console.log('点击查看图片row', row)

      if (!row.pic_file_id_out && !row.pic_file_id_in) {
        this.$toast('暂无进出场图片')
        return
      }

      this.inoutImgs = []

      this.vh_out_id = row.vh_out_id
      this.showImg = true
      this.isLoadingImg = true

      try {
        if (row.pic_file_id_in) {
          await this.fetchInoutImg(row.pic_file_id_in, 'in')
        }

        if (row.pic_file_id_out) {
          await this.fetchInoutImg(row.pic_file_id_out, 'out')
        }

        this.isLoadingImg = false
      } catch (e) {
        console.error(e)
        this.$toast('图片加载异常')
      } finally {
        this.$toast.clear()
      }
    },
    async fetchInoutImg (id, direction) {
      const para = {
        pic_file_id: id
      }

      try {
        const { data } = await axios({
          url: common.reqMqCloudUrl + '/api/no_sign/request.pls_req',
          method: 'POST',
          data: {
            sid: this.sid || this.$route.query.sid,
            method: this.escapeImgTopic,
            params: para
          },
          headers: {
            'content-type': 'application/json'
          }
        })

        console.log(`获取到${direction === 'in' ? '进场' : '出场'}图片结果`, data)

        if (data.code === 10000 && data.data) {
          this.inoutImgs.push({
            id: direction === 'in' ? '0' : '1',
            direction: direction,
            url: data.data.img,
            text: direction === 'in' ? '进场图片' : '出场图片',
            loadError: !data.data.img
          })
          console.log('this.inoutImgs', this.inoutImgs)
        } else {
          this.$toast(data.msg || `查询${direction === 'in' ? '进场' : '出场'}照片出错`)
        }
      } catch (e) {
        console.error(e)
        throw new Error(`获取${direction}图片异常`)
      }
    },
    formatDate (date) {
      return common.format(new Date(date), 'yyyy-MM-dd hh:mm:ss')
    },
    onImgError (item) {
      item.loadError = true
    },
    onVideoError (e) {
      console.error('视频加载失败', e)
      Toast('视频加载失败，请检查网络连接或稍后重试')
    },
    // Dialog 关闭时停止视频播放
    onVideoDialogClosed () {
      this.stopVideo()
    },
    // 停止视频播放
    stopVideo () {
      const video = this.$refs.videoPlayer
      if (video) {
        try {
          // 暂停视频
          video.pause()
          // 重置播放时间
          video.currentTime = 0
          // 清空视频源（重要：防止继续播放）
          video.src = ''
          video.srcObject = null
          // 加载空源，确保完全停止
          video.load()
          console.log('视频已停止播放')
        } catch (error) {
          console.error('停止视频播放失败', error)
        }
      }
      // 清空视频 URL
      this.videoUrl = ''
    }
  },
  filters: {
    filterVH (num) {
      const reg = /^N.*/
      if (reg.test(num)) {

      }
    },
    filterClass (num) {
      const reg = /^N.*/
      if (num.length < 8) {
      }
      if (reg.test(num)) {

      }
    },
    filterTimeIn (time) {
      try {
        if (time) {
          const formatTime = common.format(new Date(time), 'yyyy-MM-dd hh:mm:ss')
          return formatTime
        } else {
          return '无入场时间'
        }
      } catch (e) {
        return '不支持的时间格式'
      }
    },
    filterTimeOut (time) {
      try {
        if (time) {
          // const formatTime = common.format(time).format('yyyy-MM-dd hh:mm:ss')
          const formatTime = common.format(new Date(time), 'yyyy-MM-dd hh:mm:ss')
          return formatTime
        } else {
          return '无出场时间'
        }
      } catch (e) {
        return '不支持的时间格式'
      }
    },
    formatParkTime (item) {
      try {
        if (item.start_time && item.end_time) {
          // 计算停车时长
          var s1 = new Date(item.start_time).getTime('yyyy-MM-dd hh:mm:ss')
          var s2 = new Date(item.end_time).getTime('yyyy-MM-dd hh:mm:ss')
          //  var s1= new Date("2023-06-02T09:48:16+08:00").format('yyyy-MM-dd hh:mm:ss')
          //  var s2= new Date("2023-06-02T09:48:36+08:00").format('yyyy-MM-dd hh:mm:ss')
          // // var s2=""
          var total = (s2 - s1) / 1000
          var hour = parseInt(total / (60 * 60))
          var afterHour = total - hour * 60 * 60 // 取得算出小时数后剩余的秒数
          var min = parseInt(afterHour / 60)
          var seconds = total - hour * 60 * 60 - min * 60

          const formatParkTimes = hour + '时' + min + '分' + seconds + '秒'
          // return common.format(time, 'yyyy-MM-dd hh:mm:ss');
          return formatParkTimes
        } else {
          // return '无入场时间';
        }
        // })
      } catch (e) {
        // return '不支持的时间格式';
      }
    }
  },
  beforeDestroy () {
    // 组件销毁前停止视频播放
    this.stopVideo()
  }
}
</script>
<style scoped>
.backBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000; /* 高于 .topTime */
}
.container {
  /* margin-top: .22rem; */
  padding: 0.15rem 0.16rem 0;
  background-color: #f8f7fc;
  padding-top: 1.08rem;
  padding-bottom: 0.5rem;
}
.escapeListEmptyBox{
  padding: 0.16rem;
  background-color: #fff;

}
.mask_layout {
  z-index: 9999;
  background-color: transparent;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.escapeListBox {
  /* border: 1px solid gray; */
  /* padding: 0.1rem; */
  /* margin-top: 0.1rem; */
  /* background-color: #fff; */
  /* margin-top: 0.1rem; */
  margin-bottom: 0.16rem;
}

.escapeListBox .boxTop {
  padding: 0.1rem 0.1rem 0 0.1rem;
  background-color: #fff;
}
.escapeListBox .boxBottom {
  padding: 0 0.1rem 0.1rem 0.1rem;
  background-color: #fff;
}

.row1 {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction: column;
}

.row1 .number {
  /* width: 100%; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: 0.22rem;
  font-weight: bold; */
  /* margin-right: .06rem; */
}
.row1 .ddh {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* font-size: 0.14rem; */
  margin-top: 0.06rem;
  /* font-weight: bold; */
  /* margin-right: .06rem; */
}

.row1 .normal {
  /* max-width: 180px; */
  font-size: 0.14rem;
  color: #333;
  /* margin-left: 0.06rem; */
  line-height: 0.2rem;

  /* padding: 0.01rem 0.04rem; */
  /* border-radius: 0.12rem; */
  /* font-weight: normal; */
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.row1 .special {
  /* font-size: 0.16rem; */
  padding: 0.01rem 0.04rem;
  color: #7eab4c;
  background: #e9f9dc;
  border-radius: 0.12rem;
}

.row2 {
  margin-top: 0.36rem;
  text-align: center;
  /* font-size: 0.16rem; */
}

.row3 {
  margin-top: 0.12rem;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.row3 .code {
  /* font-size: 0.28rem; */
  color: #333;
  font-weight: bold;
  margin-right: 0.06rem;
}

.row3 .number {
  /* font-size: 0.42rem; */
  color: #333;
  font-weight: bold;
}

.itemText {
  /* color: #999 !important; */
  /* font-size: 0.14rem !important; */
  margin-top: 0.08rem;
  /* 1rem=100px */
  height: 0.2rem;
  line-height: 0.2rem;
  /* height: 35px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border-top: 0.01rem solid #ededed; */
  /* border-bottom: 0.01rem solid #ededed; */
}

.itemText .time-tip,
.itemText .in-time {
  font-size: 0.14rem !important;
  /* font-weight: lighter !important; */
  color: #999 !important;
  /* font-family: PingFangSC-Regular, sans-serif; */
}

.itemText .in-time {
  font-size: 0.14rem !important;
  /* font-weight: lighter !important; */
  color: #333 !important;
  /* font-family: PingFangSC-Regular, sans-serif; */
}

.imgBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0.2rem;
}
.imgBox .imgItem {
  /* width: 65%;
  margin-bottom: 3%; */
}

.imgBox img {
  width: 100%;
  height: 100%;
}
/* .row4 .time-tip {
  color: #999;
  font-size: 0.14rem;
} */
/*
.row4 .in-time {
  color: #999;
  font-size: 0.14rem;
}

.row5,
.row6 {
  margin-top: 0;
  border-top: none;
} */

.escPrice {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* margin-top: 0.1rem; */
}
.escPrice > .couponPrice {
  line-height: 0.25rem;
  /* text-align: center; */
  font-size: 0.2rem;
  font-weight: bold;
  /* color: rgba(238, 38, 10, 1); */
  color: #333;
  /* font-family: PingFangSC-Medium, sans-serif !important; */
}
.escPrice > .tit {
  /* text-align: center; */
  font-size: 0.12rem;
  line-height: 0.17rem;
  /* font-weight: bold; */
  color: #333;
}
.itemText > .viewImg {
  /* font-size: 0.14rem; */
  color: #1989fa !important;
}

.boxBottom {
  font-size: 0.14rem !important;
  color: #999 !important;
}
.boxBottom .comment {
  /* margin-top: 0.08rem; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* font-family: PingFangSC-Regular, sans-serif; */
  padding-top: 0.1rem;
}
.comment > .in-time {
  display: flex;
  max-width: 250px;
  text-align: right;
  color: #333;
  /* white-space: pre-wrap; */
  /* overflow: hidden;
  text-overflow: ellipsis; */
}

.button-row-pay {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* padding-top: 10px; */
  margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  /* font-family: PingFangSC-Regular, sans-serif; */
}
.escBtn {
  /* width: 1.6rem; */
  /* height: 0.48rem; */
}
/* ::v-deep .van-dialog__footer {
  margin-top: 5% !important;
} */

.van-divider {
  margin: 8px 0;
  border-color: gray;
}

.topTime{
  width: 375px;
  /* height: 45.5px; */
  /* 自动布局 */
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10.5px 14px;
  row-gap: 0px;
  flex-wrap: wrap;
  align-content: center;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  position: fixed;
  top: 46px;
  left: 0;
  z-index: 999;
}
.topTimeText{
    font-family: Roboto;
font-size: 12.25px;
font-weight: normal;
line-height: 17.5px;
letter-spacing: normal;
color: #4B5563;
  }

  .topTimeDate{
    /* 自动布局子元素 */
    width: 57.75px;
    /* height: 24.5px; */
    /* 自动布局 */
    display: flex;
    justify-content: center;
    align-items: center;
    /* flex-direction: column; */
    padding: 3.5px 10.5px;
    gap: 0px 10px;
    flex-wrap: wrap;
    align-content: flex-start;
    z-index: 0;
    border-radius: 9999px;
    background: #EFF6FF;
    font-size: 12.25px;
    font-weight: normal;
    /* line-height: 17.5px; */
    text-align: center;
    letter-spacing: normal;
    color: #3B82F6;
  }
  .pageOptionsBox{
    width: 3.75rem;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    box-sizing: border-box;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #F3F4F6;
  }
  /* 视频播放对话框样式 */
  ::v-deep .video-dialog {
    max-width: 90vw !important;
    width: 90vw !important;
  }
  ::v-deep .video-dialog .van-dialog__content {
    padding: 0.16rem !important;
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .videoBox {
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
  }
  .video-player {
    width: 100%;
    max-width: 100%;
    height: auto;
    max-height: 70vh;
    border-radius: 4px;
    background: #000;
    display: block;
    object-fit: contain;
    box-sizing: border-box;
  }
  .video-error {
    text-align: center;
    padding: 0.4rem 0.2rem;
    color: #999;
    font-size: 0.14rem;
  }
</style>
